const MultiSelect = {
  mounted() {
    this.input = this.el.querySelector(`#${this.el.id}_query`);
    this.options = () => Array.from(this.el.querySelectorAll("[role='option']"));
    this.focusedIndex = -1;

    this.setSkipClickAway = () => {
      this.el.setAttribute('data-skip-click-away', 'true');
      setTimeout(() => this.el.setAttribute('data-skip-click-away', 'false'), 150);
    };

    this.handleInputKeydown = (e) => {
      const opts = this.options();
      const listbox = this.el.querySelector("[role='listbox']");
      const isOpen = listbox !== null;

      switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        e.stopPropagation();
        this.setSkipClickAway();
        if (!isOpen) {
          document.getElementById(`listbox-${this.el.id}`).classList.toggle('hidden');
          document.getElementById(`chevron-${this.el.id}`).classList.toggle('rotate-180');

          const trigger = document.getElementById(`dropdown-trigger-${this.el.id}`);
          const expanded = trigger.getAttribute('aria-expanded') === 'true';

          trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          this.focusedIndex = 0;
        } else {
          this.focusedIndex = (this.focusedIndex + 1) % opts.length;
        }
        this.updateFocusVisual();
        break;

      case 'ArrowUp':
        e.preventDefault();
        e.stopPropagation();
        this.setSkipClickAway();
        if (!isOpen) {
          document.getElementById(`listbox-${this.el.id}`).classList.toggle('hidden');
          document.getElementById(`chevron-${this.el.id}`).classList.toggle('rotate-180');

          const trigger = document.getElementById(`dropdown-trigger-${this.el.id}`);
          const expanded = trigger.getAttribute('aria-expanded') === 'true';

          trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          this.focusedIndex = opts.length - 1;
        } else {
          this.focusedIndex = (this.focusedIndex - 1 + opts.length) % opts.length;
        }

        this.updateFocusVisual();
        break;

      case 'Escape':
        document.getElementById(`listbox-${this.el.id}`).classList.add('hidden');
        document.getElementById(`chevron-${this.el.id}`).classList.remove('rotate-180');
        document.getElementById(`dropdown-trigger-${this.el.id}`).setAttribute('aria-expanded', 'false');
        break;

      default:
        break;
      }
    };

    this.updateFocusVisual = () => {
      this.options().forEach((opt, i) => {
        if (i === this.focusedIndex) {
          opt.classList.add('bg-blue-100');
        } else {
          opt.classList.remove('bg-blue-100');
        }
      });
    };

    this.handleListboxKeydown = (e) => {
      const opts = this.options();

      switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        this.focusedIndex = (this.focusedIndex + 1) % opts.length;
        opts[this.focusedIndex]?.focus();
        break;

      case 'ArrowUp':
        e.preventDefault();
        this.focusedIndex = (this.focusedIndex - 1 + opts.length) % opts.length;
        opts[this.focusedIndex]?.focus();
        break;

      case 'Enter':
      case ' ':
        e.preventDefault();
        opts[this.focusedIndex]?.click();
        this.input.focus();
        break;

      case 'Escape':
        e.preventDefault();
        document.getElementById(`listbox-${this.el.id}`).classList.add('hidden');
        document.getElementById(`chevron-${this.el.id}`).classList.remove('rotate-180');
        document.getElementById(`dropdown-trigger-${this.el.id}`).setAttribute('aria-expanded', 'false');
        this.input.focus();
        break;

      default:
        break;
      }
    };

    this.handleClickOutside = (e) => {
      if (
        !this.el.contains(e.target) &&
        this.el.getAttribute('data-skip-click-away') !== 'true'
      ) {
        document.getElementById(`listbox-${this.el.id}`)?.classList.add('hidden');
        document.getElementById(`chevron-${this.el.id}`)?.classList.remove('rotate-180');
        document.getElementById(`dropdown-trigger-${this.el.id}`)?.setAttribute('aria-expanded', 'false');
      }
    };

    this.handleFocusOut = (_event) => {
      setTimeout(() => {
        const active = document.activeElement;

        if (!this.el.contains(active)) {
          document.getElementById(`listbox-${this.el.id}`)?.classList.add('hidden');
          document.getElementById(`chevron-${this.el.id}`)?.classList.remove('rotate-180');
          document.getElementById(`dropdown-trigger-${this.el.id}`)?.setAttribute('aria-expanded', 'false');
        }
      }, 0);
    };

    this.input.addEventListener('keydown', this.handleInputKeydown);
    this.el.addEventListener('keydown', this.handleListboxKeydown);
    this.el.addEventListener('focusout', this.handleFocusOut);
    document.addEventListener('click', this.handleClickOutside);

    this.el.addEventListener('click', (e) => {
      if (e.target.closest("[role='option']")) {
        setTimeout(() => this.input.focus(), 0);
      }
    });
  },

  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};

export default MultiSelect;

